export default __webpack_public_path__ + "static/media/pokedex1.f81594a2.jpg";